import { getCurrentLocale, resolveLocale } from './locale.js';

export interface CurrencyFormatterOptions extends Omit<
  Intl.NumberFormatOptions,
  'style' | 'currency'
> {
  readonly locale?: string;
}

function parseValue(value: number | string): number {
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isNaN(parsed) ? Number.NaN : parsed;
}

export function formatCurrency(
  value: number | string,
  currency: string,
  options: CurrencyFormatterOptions = {},
): string {
  const amount = parseValue(value);
  if (Number.isNaN(amount)) return '—';
  const { locale, ...formatOptions } = options;
  const resolvedLocale = resolveLocale(locale ?? getCurrentLocale());
  const code = currency.toUpperCase();
  try {
    return new Intl.NumberFormat(resolvedLocale, {
      style: 'currency',
      currency: code,
      ...formatOptions,
    }).format(amount);
  } catch {
    return `${code} ${new Intl.NumberFormat(resolvedLocale, formatOptions).format(amount)}`;
  }
}

/** Rounds a numeric value to the nearest integer, matching legacy booking
 *  engine behavior where no decimal values are displayed. */
export function roundRate(value: number | string): string {
  const parsed = parseValue(value);
  if (Number.isNaN(parsed)) return '0';
  return String(Math.round(parsed));
}
